// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ardoq-card {
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  padding-bottom: 56px;
  cursor: pointer;
}
.ardoq-card:hover {
  opacity: 0.9;
}

@media only screen and (min-width: 720px) {
  .ardoq-card {
    width: 250px;
    height: 345px;
  }
  .ardoq-card-img {
    height: 150px;
    width: 190px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
.ardoq-card-img-container {
  padding-top: 18px;
}

.ardoq-card-img {
  width: 190px;
  height: 150px;
  object-fit: contain;
}

.ardoq-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
}

.ardoq-icon {
  font-size: 7rem;
  color: var(--ion-color-medium);
}

.ardoq-card-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 9px 2px 0px 2px;
  gap: 6px;
}

.ardoq-card-collection {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  padding: 8px;
  white-space: normal;
  word-break: break-word;
  text-align: center;
}

.ardoq-card-title-text {
  font-size: 0.8rem;
  color: var(--ion-color-primary-contrast);
  margin-bottom: 2px;
  text-align: center;
}

.ardoq-card-embed-option {
  position: absolute;
  bottom: 62px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.97rem;
  color: var(--ion-color-medium);
  cursor: default;
}

.ardoq-card-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  box-shadow: none;
  background: var(--ion-card-background, var(--ion-color-tertiary));
  display: flex;
  justify-content: center;
  padding: 4px 0;
}

.embed-card-fav-btn {
  width: 90%;
  max-width: 220px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/embed-dashboard-card/embed-dashboard-card.component.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AAAF;AAEE;EACE,YAAA;AAAJ;;AAIA;EACE;IACE,YAAA;IACA,aAAA;EADF;EAIA;IACE,aAAA;IACA,YAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EAFF;AACF;AAMA;EACE,iBAAA;AAJF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAJF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AALF;;AAQA;EACE,eAAA;EACA,8BAAA;AALF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,QAAA;AANF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAPF;;AAWA;EACE,iBAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;AARF;;AAYA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;AATF;;AAaA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,iEAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AAVF;;AAcA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;AAXF","sourcesContent":["// Card shell — mirrors .report-card-shell\n.ardoq-card {\n  border-radius: 18px;\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 56px;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.9;\n  }\n}\n\n@media only screen and (min-width: 720px) {\n  .ardoq-card {\n    width: 250px;\n    height: 345px;\n  }\n\n  .ardoq-card-img {\n    height: 150px;\n    width: 190px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n// Image area — mirrors .report-card-img-container + .report-card-img\n.ardoq-card-img-container {\n  padding-top: 18px;\n}\n\n.ardoq-card-img {\n  width: 190px;\n  height: 150px;\n  object-fit: contain;\n}\n\n// Fallback icon when no ImageURI — same height as the image slot\n.ardoq-icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 150px;\n}\n\n.ardoq-icon {\n  font-size: 7rem;\n  color: var(--ion-color-medium);\n}\n\n// Info block — mirrors .report-card-info\n.ardoq-card-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 9px 2px 0px 2px;\n  gap: 6px;\n}\n\n// Label (embed title) — mirrors .report-card-collection\n.ardoq-card-collection {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 12px;\n  padding: 8px;\n  white-space: normal;\n  word-break: break-word;\n  text-align: center;\n}\n\n// CollapsableTitle — mirrors .report-card-title-text\n.ardoq-card-title-text {\n  font-size: 0.8rem;\n  color: var(--ion-color-primary-contrast);\n  margin-bottom: 2px;\n  text-align: center;\n}\n\n// EmbedOption badge — mirrors .report-card-desc-link\n.ardoq-card-embed-option {\n  position: absolute;\n  bottom: 62px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.97rem;\n  color: var(--ion-color-medium);\n  cursor: default;\n}\n\n// Footer — mirrors .report-card-footer\n.ardoq-card-footer {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  box-shadow: none;\n  background: var(--ion-card-background, var(--ion-color-tertiary));\n  display: flex;\n  justify-content: center;\n  padding: 4px 0;\n}\n\n// Favorite button — mirrors .report-card-fav-btn\n.embed-card-fav-btn {\n  width: 90%;\n  max-width: 220px;\n  font-weight: 500;\n}\n\n//   font-weight: 500;\n// }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
